// extracted by mini-css-extract-plugin
export default {"voice_chat_footer":"Footer_voice_chat_footer__sAElP","show":"Footer_show__VoYOP","close":"Footer_close__Txj+h","enter":"Footer_enter__1h+E7","mini_mode":"Footer_mini_mode__c3yjS"};